import React, { FC, memo, useContext } from 'react'

import { Container, ReviewsWrapper, SliderContainer, StyledCarouselProvider, StyledSlider } from './styles'
import { useTranslation } from '../../../hooks/locale'
import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import { Subtitle, Title, TitleContainer } from '../common/styles'
import ReviewsCard from '../../common/reviews-card'
import { Slide } from 'pure-react-carousel'
import { ScreenContext } from 'react-components'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { cardEventCategories } from '../../../services/analytics-service/categories'

interface Props {
    topRatedObjectsSection: ListingSectionTransport
    breadcrumbList?: BreadcrumbListTransport
}

const ReviewsSection: FC<Props> = ({ topRatedObjectsSection, breadcrumbList }) => {
    const { heading, objects: reviewObjects } = topRatedObjectsSection
    const { t } = useTranslation()
    const { isTablet, isDesktop } = useContext(ScreenContext)

    return (
        <Container id="reviews">
            <TitleContainer>
                <Title>{heading}</Title>
                <Subtitle>{t('reviewsSubTitle')}</Subtitle>
            </TitleContainer>

            {isDesktop ? (
                <ReviewsWrapper>
                    {reviewObjects.map((item, index) => (
                        <ReviewsCard
                            key={`review-card-${index}`}
                            position={index}
                            listing={item}
                            breadcrumbList={breadcrumbList}
                            pageName={cardEventCategories.pages.REGION_LANDING_PAGE}
                            sectionName={cardEventCategories.sections.REVIEW}
                        />
                    ))}
                </ReviewsWrapper>
            ) : (
                <SliderContainer>
                    <StyledCarouselProvider
                        totalSlides={reviewObjects.length}
                        visibleSlides={isTablet ? 1.75 : 1.1}
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        isIntrinsicHeight
                        lockOnWindowScroll
                        dragStep={1}
                        step={1}
                        center
                    >
                        <StyledSlider $transitionTime={0.2}>
                            {reviewObjects.map((reviewObject, index) => (
                                <Slide index={reviewObject.id} key={`${index}_${reviewObject.id}`}>
                                    <ReviewsCard
                                        key={reviewObject.id}
                                        listing={reviewObject}
                                        position={index}
                                        breadcrumbList={breadcrumbList}
                                        pageName={cardEventCategories.pages.REGION_LANDING_PAGE}
                                        sectionName={cardEventCategories.sections.REVIEW}
                                    />
                                </Slide>
                            ))}
                        </StyledSlider>
                    </StyledCarouselProvider>
                </SliderContainer>
            )}
        </Container>
    )
}

export default memo(ReviewsSection)
